var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.allowSendingMessages
      ? _c(
          "div",
          {
            staticClass:
              "flex flex-row items-center h-16 rounded-md bg-white w-full px-4"
          },
          [
            _c("div", { staticClass: "flex-grow ml-4" }, [
              _c("div", { staticClass: "relative w-full" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.body,
                      expression: "body"
                    }
                  ],
                  ref: "editor",
                  staticClass:
                    "flex w-full border rounded-md focus:outline-none focus:border-indigo-300 pl-4 h-10 text-sm",
                  attrs: { type: "text", placeholder: "Type your reply" },
                  domProps: { value: _vm.body },
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.sendMessage($event)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.body = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _c("div", { staticClass: "ml-4" }, [
              _c(
                "button",
                {
                  staticClass:
                    "flex items-center justify-center bg-indigo-500 hover:bg-indigo-600 rounded-md text-white px-2 py-2 flex-shrink-0",
                  on: { click: _vm.sendMessage }
                },
                [
                  _c("span", { staticClass: "ml-1" }, [
                    _c(
                      "svg",
                      {
                        staticClass: "w-4 h-4 transform rotate-45 -mt-px",
                        attrs: {
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                          }
                        })
                      ]
                    )
                  ])
                ]
              )
            ])
          ]
        )
      : _c("div", [
          _c(
            "p",
            { staticClass: "text-sm text-center py-4 bg-white text-gray-700" },
            [
              _vm._v(
                " You can't send message to this customer - Time limit exceeded "
              )
            ]
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }